export enum GeographicalZone {
  METROPOLE = 'metropole',
  ALSACE_MOSELLE = 'alsace-moselle',
}
